import { FilterList, noop } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useState } from 'react';

import SearchInput from '../../../../../primitives/form/SearchInput/SearchInput';
import FormTemplateTrialContainerCard from '../presentational/FormTemplateTrialContainerCard/FormTemplateTrialContainerCard';
import FormTemplateError from './FormTemplateError';

function FormTemplateTrialContainerList(props) {
  const {
    allTrialContainers,
    trialContainerRequestError = {},
    trialContainerRequestLoading = false,
    onSelectTrialContainer = noop,
  } = props;

  const [trialContainerNameFilter, setTrialContainerNameFilter] = useState('');

  const filterTrialContainers = (event) => {
    setTrialContainerNameFilter(event.target.value);
  };

  const displayError = () => {
    if (!trialContainerRequestError || Object.entries(trialContainerRequestError).length === 0) return false;
    return true;
  };

  if (trialContainerRequestLoading === true) {
    return (
      <>
        <SearchInput
          value={trialContainerNameFilter}
          placeholderText="Search Trial Containers"
          handleOnChange={filterTrialContainers}
        />
        <div className="form-template-trial-container-list">
          <FilterList filterProperty="name" filterValue={trialContainerNameFilter}>
            <FormTemplateTrialContainerCard key={1} name="..." active={false} titleClass="loader-text" />
            <FormTemplateTrialContainerCard key={2} name="..." active={false} titleClass="loader-text" />
          </FilterList>
        </div>
      </>
    );
  }

  if (displayError() === false) {
    return (
      <>
        <SearchInput
          value={trialContainerNameFilter}
          placeholderText="Search Trial Containers"
          handleOnChange={filterTrialContainers}
        />
        <div className="form-template-trial-container-list">
          <FilterList filterProperty="name" filterValue={trialContainerNameFilter}>
            {allTrialContainers.map((trialContainer) => {
              return (
                <FormTemplateTrialContainerCard
                  key={trialContainer.id}
                  name={trialContainer.name}
                  active={trialContainer.active}
                  disabled={trialContainer.requiredFormTemplateInUse}
                  id={trialContainer.id}
                  onSelectTrialContainer={onSelectTrialContainer}
                />
              );
            })}
          </FilterList>
        </div>
      </>
    );
  }
  return <FormTemplateError source="api" handleLog customError={trialContainerRequestError} disableWrapperClass />;
}

FormTemplateTrialContainerList.propTypes = {
  allTrialContainers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  trialContainerRequestError: PropTypes.objectOf(PropTypes.shape()),
  trialContainerRequestLoading: PropTypes.bool,
  onSelectTrialContainer: PropTypes.func,
};

export default FormTemplateTrialContainerList;
